/* Nossas Lojas - carrega e toca os videos das lojas so quando aparecem na tela */
(function () {
  var vids = document.querySelectorAll('.lplj-card__video[data-src]');
  if (!vids.length) return;
  function load(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) load(e.target);
      else e.target.pause();
    });
  }, { rootMargin: '120px' });
  vids.forEach(function (v) { io.observe(v); });
})();
